<div class="container-box">
  <app-table-header
    (btnUpdateClick)="reloadTrigger$.next()"
    tableTitle="Cross F7 Cancellate"
  ></app-table-header>
  <div>
    <div class="table-container">
      <app-new-table
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [initialSort]="{
          active: 'id',
          direction: 'desc'
        }"
        [reloadTrigger$]="reloadTrigger$"
      ></app-new-table>
    </div>
  </div>
</div>
